import { Observer } from "mobx-react";
import React, { useContext } from "react";
import styled from "styled-components";
import { GetQuestionFormResponse } from "../../../api/questionForm/CvpGetQuestionForm";
import { useLocStore } from "../../../wsLocalization";
import { LocContext } from "../../../wsLocalization/LocContext";
import {
  useLatestQueries,
  useLatestQuery,
} from "../../../WSUtils/useLatestQuery";
import { UserInfoContext } from "../../../WSUtils/UserInfoContext";
import { withWSErrorContainer } from "../../../WSUtils/withWSErrorContainer";
import { WSFormGrid } from "../../../WSUtils/WSFormGrid";
import { sentryAssertData } from "../../../WSUtils/wsSentry";
import { CVEditContext } from "../CVEditContext";
import { CVEQuestionForm } from "./CVEQuestionForm";

export const CVEditQuestionsStep = withWSErrorContainer(() => {
  const L = useLocStore(LocContext.CV);
  const cvEditContext = useContext(CVEditContext);
  const userInfo = useContext(UserInfoContext);
  const { irel, trel } = cvEditContext?.applyingForJob ?? {};

  const { data: questionFormsForCase } = useLatestQuery(
    ["questionFormAPI.getQuestionFormsForCase", irel, trel],
    () =>
      userInfo.fullAPI.questionFormAPI.getQuestionFormsForCase({
        userInfo,
        relatedId: irel,
        relatedType: trel,
      })
  );

  const queries =
    useLatestQueries(
      questionFormsForCase?.items?.map((item) => {
        return {
          queryFn: () => {
            return userInfo.fullAPI.questionFormAPI.getQuestionForm({
              userInfo,
              formId: item.id,
            });
          },
          queryKey: ["questionFormAPI.questionFormsForCase", item.id],
        };
      }) ?? []
    ) ?? [];

  sentryAssertData([questionFormsForCase, ...queries.map((q) => q?.data)], {
    userInfo,
  });

  const questionForms: GetQuestionFormResponse[] =
    queries?.filter((q) => !!q.data).map((q) => q.data) ?? [];

  return (
    <Observer
      render={() => {
        return (
          <CVEditApplicationStepStyles className="cve-questions-step cve-step">
            {questionForms.map((questionForm) => (
              <CVEQuestionForm
                item={questionForm.item}
                key={questionForm.item.id}
                header={L.id("ca1e3d30c659").loc("Spørreskjema")}
                description={L.id("5e3a785419e3").loc(
                  "Vennligst svar på spørsmålene"
                )}
              />
            ))}
          </CVEditApplicationStepStyles>
        );
      }}
    />
  );
});

const CVEditApplicationStepStyles = styled(WSFormGrid)`
  &.cve-questions-step {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: space-between;

    max-width: 520px;
  }
`;
